import styled from 'styled-components';
import { Base, Theme } from 'styled';

export const Body = styled(Base)`
  ${({ theme }) => theme.typography.variants.primary.xs};
`;

export const Container = styled(Base)`
  ${({ theme }) => theme.global.blogPostContentPaddingX};
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${Theme.mediaQueries.xl} {
    margin-top: 3.75rem;
  }
`;

export const ImgContainer = styled(Base)`
  width: calc(100% + 1.5rem * 2);
  margin-left: -1.5rem;

  ${Theme.mediaQueries.md} {
    width: 100vw;
    margin-left: ${({ theme }) =>
      `calc((100vw - ${theme.sizes.blogPostViewMaxWidth}) / 2 * -1)`};
  }

  ${Theme.mediaQueries.xl} {
    width: 100%;
    margin-left: unset;
  }
`;

export const Title = styled.h1`
  margin-top: 2rem;
  margin-bottom: 1.5rem;
  ${({ theme }) => theme.typography.variants.primary.xl};
`;

export const MetaContainer = styled(Base)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const PublishedDate = styled(Body)`
  display: flex;
`;
